module.exports = __webpack_public_path__ + "img/base_hiver_skis.128d0e1b.svg";